module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "placeholder padding mb-4"
  }, [_c('b', [_vm._v("\n            Hvordan skal værdien af værdikæden beregnes?\n             \n            "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": 'settings.budget_calc'
    }
  })], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "mr-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCalc),
      expression: "budgetCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "budget-calculation",
      "value": "calculation"
    },
    domProps: {
      "checked": _vm._q(_vm.budgetCalc, "calculation")
    },
    on: {
      "change": [function($event) {
        _vm.budgetCalc = "calculation"
      }, function($event) {
        return _vm.selectBudgetCalc('calculation')
      }]
    }
  }), _vm._v("\n            Kalkulation\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "mr-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCalc),
      expression: "budgetCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "budget-calculation",
      "value": "budget"
    },
    domProps: {
      "checked": _vm._q(_vm.budgetCalc, "budget")
    },
    on: {
      "change": [function($event) {
        _vm.budgetCalc = "budget"
      }, function($event) {
        return _vm.selectBudgetCalc('budget')
      }]
    }
  }), _vm._v("\n            Budget\n        ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCalc),
      expression: "budgetCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "budget-calculation",
      "value": "both"
    },
    domProps: {
      "checked": _vm._q(_vm.budgetCalc, "both")
    },
    on: {
      "change": [function($event) {
        _vm.budgetCalc = "both"
      }, function($event) {
        return _vm.selectBudgetCalc('both')
      }]
    }
  }), _vm._v("\n            Budget + kalkulation\n        ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a59a59b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/components/valuechainCalculation.vue
// module id = 919
// module chunks = 0